import * as Yup from "yup";

export const state = { email: "", password: "" };

export const schema = (t) =>
  Yup.object().shape({
    email: Yup.string()
      .trim()
      .required(`${t("authPages:email_required")}`)
      .email(`${t("authPages:invalid_email")}`)
      .max(100, `${t("authPages:max_100_characters")}`),
    password: Yup.string()
      .required(`${t("authPages:password_required")}`)
      .max(100, `${t("authPages:max_100_characters")}`),
  });
